module.exports = __webpack_public_path__ + "img/header-theme-dark.e796938e.svg";